import api from './api';
import { API_COMMANDS } from './commands';

const getStocks = async (body) => {
  console.log(body);
  const response = await api.post('', body, {
    params: { command: API_COMMANDS.STOCKS_LIST },
  });
  console.log(response);
  return response.data;
};

const getDeliveryCost = async (params) => {
  const response = await api.post('', params, {
    params: { command: API_COMMANDS.DELIVERY_COST },
  });
  return response.data;
};

const setComment = async (params) => {
  const response = await api.post('', params, {
    params: { command: API_COMMANDS.GRM_COMMENT },
  });
  return response.data;
};

export { getDeliveryCost, getStocks, setComment };
